<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="rfr-visits-page" data-cy="rfr-visits-page">
    <MasterPage :subApplication="SubApplicationTypes.ALL_FEATURES">
      <template v-if="hasAccess" v-slot:content>
        <VisitInspectionFormView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { type RoleGroup, RfrVisitsGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import { SubApplicationTypes } from "@/Domain/SubApplicationTypes";
import VisitInspectionFormView from "./VisitInspectionFormView.vue";

const roleGroups = [RfrVisitsGroup] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>
